"use client";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";

const cookieStoreExpiryInDays = 180; // days
const cookieStoreExpiry = new Date(Date.now() + cookieStoreExpiryInDays * 24 * 60 * 60 * 1000);

async function setConsentValue(consent: boolean) {
    if (typeof window !== "undefined") {
        if (window.cookieStore) {
            console.debug("Using cookiestore");
            await window.cookieStore.set({
                name: "localcookieconsent",
                value: consent.toString(),
                path: "/",
                expires: cookieStoreExpiry
            });
        } else {
            Cookies.set("localcookieconsent", consent.toString(), { path: "/", expires: 180 });
        }
    }
}

async function getConsentCookieValue() {
    if (typeof window !== "undefined") {
        if (window.cookieStore) {
            console.debug("Using cookiestore");
            return (await window.cookieStore.get("localcookieconsent"))?.value;
        } else {
            return Cookies.get("localcookieconsent");
        }
    }
    return undefined;
}

export default function useHasCookieConsent(): [boolean | undefined | null, typeof setConsentValue] {
    /**
     * If consent is undefined => consent not initialized
     * If consent is null => consent is initialized, but user has not anwered yet.
     * If consent is true or false => User has made the choice
     */
    const [hasConsent, setConsentStatus] = useState<undefined | null | boolean>(undefined);
    useEffect(() => {
        const getter = async () => {
            const cookieValue = await getConsentCookieValue();
            if (cookieValue) {
                setConsentStatus(cookieValue === "true");
            } else {
                setConsentStatus(null);
            }
        }
        getter();
    }, [])

    return [hasConsent, setConsentValue];
}